const KEY = 'pathbuddy_password_change_sign_in';

export function recordPasswordChangeSignIn(record) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(record));
  } catch (e) {
    // Storage unavailable; the save falls through to the default destination.
  }
}

export function readPasswordChangeSignIn() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
    return parsed;
  } catch (e) {
    return null;
  }
}

export function clearPasswordChangeSignIn() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // Nothing to clear.
  }
}
